"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    install: function (Vue, options) {
        var trackError = options.trackError;
        Vue.prototype.$trackError = function (type, message) { return trackError(type, message); };
    }
};
